import { render, staticRenderFns } from "./experiments.vue?vue&type=template&id=19592ded"
import script from "./experiments.vue?vue&type=script&lang=js"
export * from "./experiments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports